import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=037ea871&scoped=true&"
import script from "./Specialty.vue?vue&type=script&lang=js&"
export * from "./Specialty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ea871",
  null
  
)

export default component.exports